import styled from '@emotion/styled';
import {
  AppBar,
  Badge,
  Box,
  createTheme,
  TextField,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';

export const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff', // Text color
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#fff8', // Semi-transparent underline
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: '#fff', // Solid underline on hover
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff', // Solid underline on focus
    },
  },
})(TextField);

export const tabButtonStyles = {
  padding: '.5rem 1rem',
  borderRadius: '50px',
};

export const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
    secondary: {
      main: '#ddb930',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

export const HeaderBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
  height: 'fit-content',
  paddingBottom: '10px',
  color: 'primary',
  top: '0px',
  boxShadow: 'none',
  justifyContent: 'start',
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#36899f',
    color: '#36899f',
    '&::after': {
      position: 'absolute',
      top: -3,
      left: -3,
      width: '150%',
      height: '150%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));

export const ButtonGroupBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: '100',
  width: '100%',
  height: '73px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#484656',
  spacing: '10px',
}));

export const Layer1 = styled(Box)(({ theme }) => ({
  // position: 'relative',
  display: 'flex',
  justifyContent: 'end',
  paddingRight: '35px',
  gap: '30px',
  zIndex: 'inherit',
  marginTop: '77px',
}));

export const EditLayer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'end',
  zIndex: 'inherit',
  gap: '3px',
  position: 'relative',
}));

export const Layer2 = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  zIndex: 'inherit',
  // paddingLeft: "41px",
  gap: '30px',
  padding: '0rem 1rem',
  paddingTop: '70px',
}));

export const Layer2Right = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  position: 'relative',
  zIndex: 'inherit',
  borderRadius: '50%',
  borderColor: '#ffffff',
  borderWidth: '4px',
  border: 'solid',
  width: '140px',
  height: '140px',
  flexShrink: 0,
}));

export const Layer2Left = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  zIndex: 'inherit',
  alignItems: 'flex-end',
  width: '50%',
  justifyContent: 'flex-end',
}));

export const Layer2LeftTop = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  zIndex: 'inherit',
  marginTop: '10px',
  justifyContent: 'end',
  // paddingRight: "35px",
  // padding: "1rem 0rem",
}));

export const Layer2LeftBottom = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  zIndex: 'inherit',
  gap: '60px',
  marginTop: '60px',
}));

export const Layer3 = styled(Layer2)(({ theme }) => ({
  position: 'relative',
  gap: '5px',
  alignItems: 'center',
  paddingTop: '19px',
}));

export const Layer4 = styled(Layer3)(({ theme }) => ({
  position: 'relative',
  flexDirection: 'column',
  alignItems: 'start',
  paddingRight: '41px',
  paddingTop: '11px',
}));

export const Layer5 = styled(Layer3)(({ theme }) => ({
  position: 'relative',
  alignItems: 'start',
  paddingTop: '16px',
  gap: '10px',
}));

export const Layer6 = styled(Layer3)(({ theme }) => ({
  position: 'relative',
  gap: '35px',
  paddingTop: '21px',
}));

export const Layer7 = styled(Layer3)(({ theme }) => ({
  position: 'relative',
  paddingTop: '8px',
}));

export const FollowTextBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'end',
  alignItems: 'center',
}));

export const BackgroundBox = styled(Box)(({ theme }) => ({
  zIndex: '100',
  position: 'absolute',
  width: '100%',
  top: '0px',
}));

export const EditText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontSize: '15px',
}));

export const FollowTitleText = styled(EditText)(({ theme }) => ({
  position: 'relative',
  fontSize: '20px',
  fontWeight: 'bold',
  cursor: 'pointer',
}));

export const TitleText = styled(FollowTitleText)(({ theme }) => ({
  left: '0px',
}));

export const ParaText = styled(TitleText)(({ theme }) => ({
  fontSize: '12px',
}));

export const GuestText = styled(ParaText)(({ theme }) => ({
  color: '#c1c1c1',
  fontWeight: 'initial',
}));

export const SiteText = styled(GuestText)(({ theme }) => ({}));

export const AboutText = styled(ParaText)(({ theme }) => ({
  fontWeight: 'inherit',
}));
